import { render, staticRenderFns } from "./review-add-block.vue?vue&type=template&id=79df4851&functional=true"
import script from "./review-add-block.vue?vue&type=script&lang=ts"
export * from "./review-add-block.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports